export default __webpack_public_path__ + "static/media/Hyundai.406f2c03.svg";